/* Rincón Educativo · inicio «Estantes por grado»: círculos de grado, flechas de estante y fecha que viene */
(function () {
  function iniciar() {
    var root = document.querySelector('[data-re]');
    if (!root) return;

    // Grados: al tocar un círculo se muestra su estante.
    // 2026-10-04 (velocidad): el cuerpo de cada estante de grado ya no viene en el HTML del inicio; se pide al tocar el grado
    // (o antes, al pasar el dedo/mouse por el círculo, y después de la primera interacción en segundo plano) a data-src = /collections/<x>?view=rincon-panel.
    var btns = root.querySelectorAll('.re-g');
    var panels = root.querySelectorAll('.re-panel');
    var ayuda = root.querySelector('[data-re-ayuda]');
    function panelDe(g) { var r = null; panels.forEach(function (p) { if (p.getAttribute('data-panel') === g) r = p; }); return r; }
    function cargar(p) {
      if (!p) return Promise.resolve();
      if (p._carga) return p._carga;
      var src = p.getAttribute('data-src');
      if (!src) return Promise.resolve();
      var cuerpo = p.querySelector('[data-re-cuerpo]');
      p._carga = fetch(src, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        if (!html.trim()) throw new Error('vacio');
        cuerpo.innerHTML = html;
        var meta = cuerpo.querySelector('meta'); if (meta) meta.remove();
        var el = cuerpo.querySelector('[data-total]');
        var t = el ? parseInt(el.getAttribute('data-total'), 10) || 0 : 0;
        var n = p.querySelector('[data-re-n]');
        if (n) n.textContent = t + ' resultado' + (t !== 1 ? 's' : '');
        p.removeAttribute('data-src');
      }).catch(function () {
        p._carga = null;
        var ver = p.querySelector('.re-ver-todo-btn');
        cuerpo.insertAdjacentHTML('beforeend', '<p class="re-vacio">No pudimos cargar el resto de este estante ahora. ' + (ver ? '<a href="' + ver.getAttribute('href') + '">Ver todo →</a>' : '') + '</p>');
      });
      return p._carga;
    }
    btns.forEach(function (b) {
      var pre = function () { cargar(panelDe(b.getAttribute('data-g'))); };
      b.addEventListener('pointerenter', pre, { once: true });
      b.addEventListener('touchstart', pre, { once: true, passive: true });
      b.addEventListener('focus', pre, { once: true });
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-g');
        btns.forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        var mostrado = null;
        panels.forEach(function (p) { var ver = p.getAttribute('data-panel') === g; p.hidden = !ver; if (ver) mostrado = p; });
        if (ayuda) ayuda.hidden = true;
        cargar(mostrado).then(function () {
          // «N resultados»: se reinicia la animación para que se note que cambió el estante, aunque los primeros kits se repitan.
          var cuenta = mostrado && mostrado.querySelector('[data-re-n]');
          if (cuenta) { cuenta.classList.remove('flash'); void cuenta.offsetWidth; cuenta.classList.add('flash'); }
          if (mostrado && !mostrado.hidden && mostrado.scrollIntoView) mostrado.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
    });
    // Después de la primera interacción del visitante, se traen los demás estantes de a uno, sin apuro, para que el próximo toque sea instantáneo.
    var precargado = false;
    function precargar() {
      if (precargado) return; precargado = true;
      var cola = [].slice.call(panels);
      (function sig() {
        var p = cola.shift(); if (!p) return;
        cargar(p).then(function () { setTimeout(sig, 600); });
      })();
    }
    ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (window.requestIdleCallback) window.requestIdleCallback(precargar, { timeout: 4000 }); else setTimeout(precargar, 1500); }, { once: true, passive: true });
    });

    // Flechas de los estantes (escritorio).
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-re-flecha]');
      if (!a) return;
      var caja = a.closest('.re-bloque');
      var fila = caja && caja.querySelector('.re-fila');
      if (!fila) return;
      var dir = a.getAttribute('data-re-flecha') === 'next' ? 1 : -1;
      fila.scrollBy({ left: dir * fila.clientWidth * 0.9, behavior: 'smooth' });
    });

    // Tarjeta de la próxima fecha: la primera que no pasó, con la fecha del visitante.
    var cards = [].slice.call(root.querySelectorAll('[data-re-fecha]'));
    var estantes = [].slice.call(root.querySelectorAll('[data-re-estante-fecha]'));
    function parse(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function hoy0() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
    var activa = null;
    function elegir() {
      var h = hoy0(), idx = null;
      // 2026-10-05: si la tarjeta «Próxima fecha escolar» no se imprime (setting apagado), la fecha sale de los propios estantes (data-re-f).
      var refs = cards.length ? cards.map(function (c) { return [c.getAttribute('data-re-i'), c.getAttribute('data-re-fecha')]; })
                              : estantes.map(function (s) { return [s.getAttribute('data-re-estante-fecha'), s.getAttribute('data-re-f')]; });
      refs.forEach(function (r) { if (idx === null && r[1] && parse(r[1]) >= h) idx = r[0]; });
      activa = null;
      cards.forEach(function (c) { var ver = c.getAttribute('data-re-i') === idx; c.hidden = !ver; if (ver) activa = c; });
      estantes.forEach(function (s) { s.hidden = s.getAttribute('data-re-estante-fecha') !== idx; });
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      if (!activa) return;
      var diff = parse(activa.getAttribute('data-re-fecha')) - new Date();
      var set = function (u, v) { var el = activa.querySelector('[data-u="' + u + '"]'); if (el) el.textContent = v; };
      if (diff <= 0) { set('d', '0'); set('h', '00'); set('m', '00'); set('s', '00'); return; }
      set('d', String(Math.floor(diff / 864e5)));
      set('h', pad(Math.floor(diff / 36e5) % 24));
      set('m', pad(Math.floor(diff / 6e4) % 60));
      set('s', pad(Math.floor(diff / 1e3) % 60));
    }
    if (cards.length || estantes.length) { elegir(); if (cards.length) { tick(); setInterval(tick, 1000); } }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
